import React from 'react';
import { envIsDevOrLess } from './_helpers';

const performanceTesting = false;

if (envIsDevOrLess() && performanceTesting) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true
  });
}
